import React from 'react'
import clsx from 'clsx'
import { Typography, Icon } from '@material-ui/core'
import { upperCase } from 'lodash'

const APPROVE = 'APPROVE'
const ERROR = 'ERROR'
const DISABLED = 'DISABLED'

const Status = (props) => {
  const { status, icon, statusText, className } = props

  const renderTextColor = () => {
    let textColor = ''
    switch (upperCase(status)) {
      case APPROVE:
        textColor = 'text-green'
        break
      case ERROR:
        textColor = 'text-red'
        break
      case DISABLED:
        textColor = 'text-grey-dark'
        break
      default:
        break
    }
    return textColor
  }
  return (
    <div
      className={clsx(
        'container flex flex-row items-center',
        renderTextColor(),
      )}
    >
      {icon && <Icon className={className}>{icon}</Icon>}
      <Typography className={`${className}`}>{statusText}</Typography>
    </div>
  )
}

export default Status
